module.exports = "<div class=\"card-request-failure\">\n  <i class=\"icon icon-cross\" ng-click=\"$ctrl.onClose()\"></i>\n  <i class=\"icon icon-warning\"></i>\n  <p ng-if=\"$ctrl.errorMsgIsEmpty()\">\n    {{'FOOD_BENEFIT.CARD_REQUEST_FAILURE.MESSAGE' | translate}}\n    <strong>{{$ctrl.days}} {{'FOOD_BENEFIT.CARD_REQUEST_FAILURE.MESSAGE_DAYS' | translate}}</strong>\n  </p>\n  <p ng-if=\"!$ctrl.errorMsgIsEmpty()\" ng-bind=\"$ctrl.errorMsg\"></p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/food-benefit.module/components/userCardList/userCardRow/homeCard/cardRequestFailure/cardRequestFailure.html
// module id = 1616
// module chunks = 0